<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="activatingPopUp = false"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nama Sub-Kategori Penyaluran Dana</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="nama sub-kategori penyaluran dana"
          class="w-full sidebar-input"
          v-model="formData.namaSubKategori"
          placeholder="Isi dengan nama kategori campaign"
        />
        <span class="text-danger text-sm">{{
          errors.first("nama sub-kategori penyaluran dana")
        }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Parent Kategori</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
                :options="option"
                :reduce="option => option.id"
                class="w-full"
                v-validate="'required'"
                data-vv-validate-on="blur"
                name="sub-kategori"
                label="name"
                v-model="formData.kategoriSelect"
                placeholder="Pilih Kategori Penyaluran Dana"
              />
        <span class="text-danger text-sm">{{
          errors.first("sub-kategori")
        }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl"
          >Cancel</vs-button
        >
        <vs-button
          
          color="success"
          class="ml-2 rounded-2xl"
          
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null }
  },
  data() {
    return {
      option : [
          {
            id : 1,
            name : "Bencana"
          },
          {
            id : 2,
            name : "Isu Sosial"
          },
        ],
      formData: {
        kategoriSelect : null,
        namaSubKategori: ""
      }
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Sub-Kategori Penyaluran Dana" : "Tambah Sub-Kategori Penyaluran Dana";
    },
    labelButton(){
        return this.passData != null ? "Edit" : "Submit";
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      }
    }
  }
};
</script>
